module.exports = __webpack_public_path__ + "img/id-card.e458e644.svg";